import { render, staticRenderFns } from "./UseMedPadalaCredits.vue?vue&type=template&id=8b1d7c24&scoped=true&"
import script from "./UseMedPadalaCredits.vue?vue&type=script&lang=js&"
export * from "./UseMedPadalaCredits.vue?vue&type=script&lang=js&"
import style0 from "./UseMedPadalaCredits.vue?vue&type=style&index=0&id=8b1d7c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1d7c24",
  null
  
)

export default component.exports